/**
 * Two explicit variants for the two ways a filter is rendered:
 *
 * - `DropdownTableFilter` — sub-menu inside the main Filters dropdown.
 *   Writes through to `filterSetter` immediately; the parent buffers and
 *   flushes on panel close.
 *
 * - `InlinePillTableFilter` — chip rendered outside the dropdown.
 *   Buffers locally and publishes on close (blur).
 *
 * The default export aliases `DropdownTableFilter` for backward compat —
 * most consumers use that path, and the audit confirmed nothing outside
 * this package picked the inline variant explicitly.
 */
export { default } from "./dropdown-item";
export { default as DropdownTableFilter } from "./dropdown-item";
export { default as InlinePillTableFilter } from "./inline-pill";
export { default as TableFilter } from "./dropdown-item";

export { MultiSelectInput } from "./filter-types";
export type { FilterOption, FilterTypes } from "./filter-types";
export type { FilterTypeProps } from "./types";
